import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import Logo from "../../../assets/images/pngs/logo.png";
import Favicon from "../../../assets/images/pngs/siju-vector-logo.png";
import { toggleNavToIconsOnHover } from "../../../store/actions/component.action";
import { MenuInitialStatus, MenuType, SubMenuType } from "../../../utils/helpers/constants";
import TokenHelper from "../../../utils/helpers/tokenHelper";
import { PermissionsEnum } from "../../../utils/helpers/permissions.enum";

const SideMenu = ({ menu }) => {

	const dispatch = useDispatch();
	const [active, setActive] = useState(menu);
	const [toggleMenu, setToggleMenu] = useState(false);
	const [dropdownMenu, setDropdownMenu] = useState(MenuInitialStatus);
	const { component, configs, profile, users } = useSelector(({ componentReducer, configsReducer, profileReducer, usersReducer }) => ({
		component: componentReducer,
		configs: configsReducer,
		profile: profileReducer,
		users: usersReducer,
	}));

	useEffect(() => {
		if (!dropdownMenu[active]) subMenu(active);
	}, [active]);

	const onHoverSubMenu = state => {
		if (!component.iconNavMode) return;
		dispatch(toggleNavToIconsOnHover(state, component.iconNavMode));
	}

	const subMenu = menuOption => {
		if (menuOption === active) setToggleMenu(!toggleMenu);
		else setToggleMenu(true);

		const dropDownData = { ...MenuInitialStatus, [menuOption]: true };
		setActive(menuOption);
		setDropdownMenu(dropDownData);
	}


	return (
		<div className="main-sidebar main-sidebar-sticky side-menu overflow-auto">
			<div className="sidemenu-logo">
				<NavLink className="main-logo" to="/">
					<img src={Logo} className="header-brand-img desktop-logo" alt="logo" />
					<img src={Favicon} className="header-brand-img icon-logo px-1" alt="logo" />
				</NavLink>
			</div>
			<div className="main-sidebar-body">
				<ul className="nav mt-3 mb-5" onMouseEnter={() => onHoverSubMenu(true)}
					onMouseLeave={() => onHoverSubMenu(false)}>
					<li className="nav-header"><span className="nav-label">Dashboard</span></li>
					<li className={`nav-item ${menu === MenuType.HOME && "active"}`}>
						<NavLink className="nav-link" to="/">
							<span className="shape1" /><span className="shape2" />
							<i className="zmdi zmdi-home sidemenu-icon" /><span className="sidemenu-label">Dashboard</span>
						</NavLink>
					</li>
					{TokenHelper.getUserRole() === 'Admin' &&
						<li className={`nav-item ${menu === MenuType.INSIGHTS && "active"}`}>
							<NavLink className="nav-link" to={`/${MenuType.INSIGHTS}`}>
								<span className="shape1" /><span className="shape2" />
								<i className="zmdi zmdi-chart sidemenu-icon" /><span className="sidemenu-label">Insights</span>
							</NavLink>
						</li>
					}
					<li className={`nav-item ${menu === MenuType.AUDIT_TRAIL && "active"}`}>
						<NavLink className="nav-link" to={`/${MenuType.AUDIT_TRAIL}`}>
							<span className="shape1" /><span className="shape2" />
							<i className="zmdi zmdi-format-list-bulleted sidemenu-icon" /><span className="sidemenu-label">Audit Trail</span>
						</NavLink>
					</li>

					<li className={`nav-item ${menu === MenuType.FINANCES && "active"} ${dropdownMenu[MenuType.FINANCES] && "show"}`}>
						<div onClick={() => subMenu(MenuType.FINANCES)} className="nav-link with-sub pointer-event">
							<span className="shape1" /><span className="shape2" />
							<i className={`zmdi zmdi-card sidemenu-icon`} />
							<span className="sidemenu-label">Finances</span>
							<i className="angle zmdi zmdi-chevron-right"></i>
						</div>
						<ul className={`nav-sub ${(dropdownMenu[MenuType.FINANCES] && toggleMenu) ? "show" : "hide"}`}>
							<li className="nav-sub-item">
								<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.WALLETS}`}>Wallets</NavLink>
							</li>


							{profile && profile.organisation && profile.organisation.wallet_configs &&
								<Fragment>
									{profile.organisation.wallet_configs.payout_organisation_wallet &&
										<li className="nav-sub-item">
											<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.WALLET_WITHDRAWALS}`}>Funds Withdrawal</NavLink>
										</li>
									}
									{profile.organisation.wallet_configs.advance_payment_status &&
										<li className="nav-sub-item">
											<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.ADVANCED_PAYMENTS}`}>Advance Payments</NavLink>
										</li>
									}
									{profile.organisation.wallet_configs.delivery_collection_status &&
										<li className="nav-sub-item">
											<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.DELIVERY_COLLECTIONS}`}>Delivery Collections</NavLink>
										</li>
									}
									{profile.organisation.wallet_configs.delivery_collection_status &&
										<li className="nav-sub-item">
											<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.SWIFT_PAYMENTS}`}>Quick Payments</NavLink>
										</li>
									}
									{profile.organisation.wallet_configs.delivery_collection_status &&
										<li className="nav-sub-item">
											<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.SWIFT_PAYMENT_CONFIGURATIONS}`}>Quick Payments Config</NavLink>
										</li>
									}
								</Fragment>
							}
							<Fragment>
								<li className="nav-sub-item">
									<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.QUICK_TOP_UP}`}>Quick Top-Up</NavLink>
								</li>
								<li className="nav-sub-item">
									<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.QUICK_TOP_UP_CONFIGURATION}`}>Quick Top-Up Configuration</NavLink>
								</li>
								<li className="nav-sub-item">
									<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.REPORTS}`}>Financial Reports</NavLink>
								</li>
								<li className="nav-sub-item">
									<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.INVOICES}`}>Invoices</NavLink>
								</li>
								<li className="nav-sub-item">
									<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.INVOICES}/${SubMenuType.INVOICE_TEMPLATES}`}>Invoice Templates</NavLink>
								</li>
								<li className="nav-sub-item">
									<NavLink className="nav-sub-link" to={`/${MenuType.FINANCES}/${SubMenuType.CONFIGS}`}>Financial Configurations</NavLink>
								</li>
							</Fragment>
						</ul>
					</li>

					{((
						(PermissionsEnum.VIEW_USERS in users.tenantPermissions || PermissionsEnum.VIEW_BUSINESSES in users.tenantPermissions
							|| PermissionsEnum.VIEW_USERS_CONFIG in users.tenantPermissions) && configs.enabledServices.USR)
						|| (
							(PermissionsEnum.VIEW_DRIVERS in users.tenantPermissions || PermissionsEnum.VIEW_DRIVER_PROFILE in users.tenantPermissions)
							&& configs.enabledServices.DRM)
						|| (
							(PermissionsEnum.VIEW_FLEET in users.tenantPermissions
								|| PermissionsEnum.CONFIGURE_FLEET_SERVICE in users.tenantPermissions) && configs.enabledServices.FLT)
						|| (
							(PermissionsEnum.VIEW_TRIPS in users.tenantPermissions || PermissionsEnum.VIEW_BOOKING_CONFIG in users.tenantPermissions
								|| PermissionsEnum.VIEW_ORGANISATION_FLEET_CATEGORY in users.tenantPermissions || PermissionsEnum.VIEW_FLEET_CHARGE in users.tenantPermissions
								|| PermissionsEnum.VIEW_BOOKING_ADDED_SERVICES in users.tenantPermissions) && configs.enabledServices.BOK)
						|| (
							(PermissionsEnum.VIEW_VEHICLE_ARRIVAL in users.tenantPermissions || PermissionsEnum.VIEW_WAREHOUSE in users.tenantPermissions
								|| PermissionsEnum.VIEW_PRODUCT in users.tenantPermissions || PermissionsEnum.VIEW_ORDERSET in users.tenantPermissions)
							&& configs.enabledServices.WHA)
					) &&
						<span className="nav-header"><span className="nav-label">Services</span></span>
					}
					{(PermissionsEnum.VIEW_USERS in users.tenantPermissions
						|| PermissionsEnum.VIEW_BUSINESSES in users.tenantPermissions || PermissionsEnum.VIEW_USERS_CONFIG in users.tenantPermissions
					) && configs.enabledServices.USR &&
						<li className={`nav-item ${menu === MenuType.USER_MANAGEMENT && "active"} ${dropdownMenu[MenuType.USER_MANAGEMENT] && "show"}`}>
							<div onClick={() => subMenu(MenuType.USER_MANAGEMENT)} className="nav-link with-sub pointer-event">
								<span className="shape1" /><span className="shape2" />
								<i className={`zmdi zmdi-accounts-outline sidemenu-icon`} />
								<span className="sidemenu-label">Users Management</span>
								<i className="angle zmdi zmdi-chevron-right"></i>
							</div>
							<ul className={`nav-sub ${(dropdownMenu[MenuType.USER_MANAGEMENT] && toggleMenu) ? "show" : "hide"}`}>
								{PermissionsEnum.VIEW_USERS in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to={`/${MenuType.SERVICES}/${MenuType.USER_MANAGEMENT}/${SubMenuType.PROFILE}`}>Users Management</NavLink>
									</li>
								}
								{PermissionsEnum.VIEW_BUSINESSES in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to={`/${MenuType.SERVICES}/${MenuType.BUSINESS_MANAGEMENT}/${SubMenuType.PROFILE}`}>Business
											Management</NavLink>
									</li>
								}
								{PermissionsEnum.VIEW_USERS_CONFIG in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to={`/${MenuType.SERVICES}/${MenuType.USER_MANAGEMENT}/${SubMenuType.CONFIGS}`}>Configurations</NavLink>
									</li>
								}
							</ul>
						</li>
					}

					{(PermissionsEnum.VIEW_DRIVERS in users.tenantPermissions || PermissionsEnum.VIEW_DRIVER_PROFILE in users.tenantPermissions) &&
						configs.enabledServices.DRM &&
						<li className={`nav-item ${menu === MenuType.DRM && "active"} ${dropdownMenu[MenuType.DRM] && "show"}`}>
							<div onClick={() => subMenu(MenuType.DRM)} className="nav-link with-sub pointer-event">
								<span className="shape1" /><span className="shape2" />
								<i className={`zmdi zmdi-accounts-list-alt sidemenu-icon`} />
								<span className="sidemenu-label">Drivers Management</span>
								<i className="angle zmdi zmdi-chevron-right"></i>
							</div>
							<ul className={`nav-sub ${(dropdownMenu[MenuType.DRM] && toggleMenu) ? "show" : "hide"}`}>
								{PermissionsEnum.VIEW_DRIVERS in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/driver-management/profile">Drivers</NavLink>
									</li>
								}
								{PermissionsEnum.VIEW_DRIVER_PROFILE in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/driver-management/configs">Configurations</NavLink>
									</li>
								}
							</ul>
						</li>
					}

					{(PermissionsEnum.VIEW_FLEET in users.tenantPermissions
						|| PermissionsEnum.CONFIGURE_FLEET_SERVICE in users.tenantPermissions) &&
						configs.enabledServices.FLT &&
						<li className={`nav-item ${menu === MenuType.FLT && "active"} ${dropdownMenu[MenuType.FLT] && "show"}`}>
							<div onClick={() => subMenu(MenuType.FLT)} className="nav-link with-sub pointer-event">
								<span className="shape1" /><span className="shape2" />
								<i className={`zmdi zmdi-directions-bus sidemenu-icon`} />
								<span className="sidemenu-label">Fleets Management</span>
								<i className="angle zmdi zmdi-chevron-right"></i>
							</div>
							<ul className={`nav-sub ${(dropdownMenu[MenuType.FLT] && toggleMenu) ? "show" : "hide"}`}>
								{PermissionsEnum.VIEW_FLEET in users.tenantPermissions && PermissionsEnum.VIEW_FLEET_PROFILE in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/fleet-management/fleet">Fleet</NavLink>
									</li>
								}
								{PermissionsEnum.CONFIGURE_FLEET_SERVICE in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/fleet-management/configs">Configurations</NavLink>
									</li>
								}
							</ul>
						</li>
					}

					{(
						PermissionsEnum.VIEW_TRIPS in users.tenantPermissions
						|| PermissionsEnum.VIEW_BOOKING_CONFIG in users.tenantPermissions
						|| PermissionsEnum.VIEW_ORGANISATION_FLEET_CATEGORY in users.tenantPermissions
						|| PermissionsEnum.VIEW_FLEET_CHARGE in users.tenantPermissions
						|| PermissionsEnum.VIEW_BOOKING_ADDED_SERVICES in users.tenantPermissions
					)
						&& configs.enabledServices.BOK &&
						<li className={`nav-item ${menu === MenuType.BOK && "active"}
                    ${dropdownMenu[MenuType.BOK] && "show"}`}>
							<div onClick={() => subMenu(MenuType.BOK)} className="nav-link with-sub pointer-event">
								<span className="shape1" /><span className="shape2" />
								<i className={`zmdi zmdi-google-maps sidemenu-icon`} />
								<span className="sidemenu-label">Booking Management</span>
								<i className="angle zmdi zmdi-chevron-right"></i>
							</div>
							<ul className={`nav-sub ${(dropdownMenu[MenuType.BOK] && toggleMenu) ? "show" : "hide"}`}>
								{PermissionsEnum.VIEW_TRIPS in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/trip-management/trips">Trips</NavLink>
									</li>
								}
								{PermissionsEnum.TRIP_QUOTE in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/trip-management/trips-quote-leads">Quote
											Leads</NavLink>
									</li>
								}
								{PermissionsEnum.VIEW_BOOKING_CONFIG in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/trip-management/configs">Configurations</NavLink>
									</li>
								}
								{PermissionsEnum.VIEW_ORGANISATION_FLEET_CATEGORY in users.tenantPermissions &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/trip-management/categories">
											Vehicle Categories
										</NavLink>
									</li>
								}
								{(PermissionsEnum.VIEW_ORGANISATION_FLEET_CATEGORY in users.tenantPermissions && PermissionsEnum.VIEW_FLEET_CHARGE in users.tenantPermissions) &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/trip-management/pricing-configs">
											Pricing Configuration
										</NavLink>
									</li>
								}
								{(PermissionsEnum.VIEW_BOOKING_ADDED_SERVICES in users.tenantPermissions && PermissionsEnum.VIEW_BOOKING_CONFIG in users.tenantPermissions) &&
									<li className="nav-sub-item">
										<NavLink className="nav-sub-link" to="/services/trip-management/value-added-services">
											Value Added Services
										</NavLink>
									</li>
								}
								<li className="nav-sub-item">
									<NavLink className="nav-sub-link" to="/services/trip-management/open-trip-configs">
										Open Trip Configuration
									</NavLink>
								</li>
							</ul>
						</li>
					}

					{(PermissionsEnum.VIEW_VEHICLE_ARRIVAL in users.tenantPermissions
						|| PermissionsEnum.VIEW_WAREHOUSE in users.tenantPermissions
						|| PermissionsEnum.VIEW_PRODUCT in users.tenantPermissions
						|| PermissionsEnum.VIEW_ORDERSET in users.tenantPermissions) && configs.enabledServices.WHA &&
						<li className={`nav-item ${menu === MenuType.WHA && "active"} ${dropdownMenu[MenuType.WHA] && "show"}`}>
							<div onClick={() => subMenu(MenuType.WHA)} className="nav-link with-sub pointer-event">
								<span className="shape1" /><span className="shape2" />
								<i className={`zmdi zmdi-store-24 sidemenu-icon`} />
								<span className="sidemenu-label">Warehouse Automation</span>
								<i className="angle zmdi zmdi-chevron-right"></i>
							</div>
							<ul className={`nav-sub ${(dropdownMenu[MenuType.WHA] && toggleMenu) ? "show" : "hide"}`}>
								<li className="nav-sub-item">
									{PermissionsEnum.VIEW_VEHICLE_ARRIVAL in users.tenantPermissions &&
										<NavLink className="nav-sub-link" to="/services/warehouse-automation/arrivals">
											Vehicle Arrivals
										</NavLink>
									}
									{PermissionsEnum.VIEW_PRODUCT in users.tenantPermissions &&
										<NavLink className="nav-sub-link" to="/services/warehouse-automation/products">
											Products
										</NavLink>
									}
									{PermissionsEnum.VIEW_WAREHOUSE in users.tenantPermissions &&
										<NavLink className="nav-sub-link" to="/services/warehouse-automation/warehouses">
											Warehouses
										</NavLink>
									}
									{PermissionsEnum.VIEW_ORDERSET in users.tenantPermissions &&
										<NavLink className="nav-sub-link" to="/services/warehouse-automation/deliveries">
											Orders and Deliveries
										</NavLink>
									}
									{/* {TokenHelper.getUserType() === UserType.ADMIN &&
										<NavLink className="nav-sub-link" to="/services/warehouse-automation/products/categories">
											Product Categories
										</NavLink>
									} */}
								</li>
							</ul>
						</li>
					}

					{TokenHelper.getUserRole() === 'Admin' &&
						<li className={`nav-item ${menu === MenuType.MARKETPLACE && "active"}`}>
							<NavLink className="nav-link" to={`/${MenuType.SERVICES}/${MenuType.MARKETPLACE}`}>
								<span className="shape1" /><span className="shape2" />
								<i className="zmdi zmdi-globe sidemenu-icon" />
								<span className="sidemenu-label">Marketplace</span>
							</NavLink>
						</li>
					}

					<span className="nav-header"><span className="nav-label">Iam and Admins</span></span>
					{/* 
						<li className={`nav-item ${menu === menuType.BILLINGS && "active"}`}>
							<NavLink className="nav-link" to="/iam/billings">
								<span className="shape1" /><span className="shape2" />
								<i className="zmdi zmdi-balance-wallet sidemenu-icon" />
								<span className="sidemenu-label">Billings</span>
							</NavLink>
						</li>
					 */}

					<li className={`nav-item ${menu === MenuType.PROFILE && "active"}`}>
						<NavLink className="nav-link" to="/iam/profile">
							<span className="shape1" /><span className="shape2" />
							<i className="zmdi zmdi-account-circle sidemenu-icon" />
							<span className="sidemenu-label">Profile</span>
						</NavLink>
					</li>

					{TokenHelper.getUserRole() === 'Admin' &&
						<li className={`nav-item ${menu === MenuType.TEAM && "active"}`}>
							<NavLink className="nav-link" to="/iam/team-members">
								<span className="shape1" /><span className="shape2" />
								<i className="zmdi zmdi-accounts-list-alt sidemenu-icon" />
								<span className="sidemenu-label">Team Members</span>
							</NavLink>
						</li>
					}

					<li className={`nav-item ${menu === MenuType.ORG && "active"}`}>
						<NavLink className="nav-link" to="/organisations">
							<span className="shape1" /><span className="shape2" />
							<i className="zmdi zmdi-account-o sidemenu-icon" />
							<span className="sidemenu-label">Organisations</span>
						</NavLink>
					</li>

					{TokenHelper.getUserRole() === 'Admin' &&
						<li className={`nav-item ${menu === MenuType.ROLES && "active"}`}>
							<NavLink className="nav-link" to="/iam/roles">
								<span className="shape1" /><span className="shape2" />
								<i className="zmdi zmdi-shield-security sidemenu-icon" />
								<span className="sidemenu-label">Roles and Permissions</span>
							</NavLink>
						</li>
					}

					<span className="nav-header"><span className="nav-label">Configuration</span></span>
					<li className={`nav-item ${menu === MenuType.API_INTEGRATION && "active"}`}>
						<NavLink className="nav-link" to="/api-integration">
							<span className="shape1" /><span className="shape2" />
							<i
								className={`zmdi zmdi-settings sidemenu-icon ${menu === MenuType.API_INTEGRATION && "zmdi-hc-spin"}`} />
							<span className="sidemenu-label">API Integration</span>
						</NavLink>
					</li>
				</ul>
			</div>
		</div>
	);
}

export default SideMenu;
